import React from 'react'
import { TbMail, TbPencil, TbPhone, TbUserSquareRounded } from 'react-icons/tb'
import { Avatar, Button, Col, FabButton, Flex, Gap, InputField, Row, Typography } from '../../../ppui'
import { Icon } from '../../../ppui/icon'
import { shortFormName } from '../../../utils/common'
import { logger } from '../../../utils/logger'
import useCommonfn from '../../../utils/useCommonfn'
import { Card, CardHeading, CardViewBox, CardViewBoxBorder } from '../../style'
import { OWNERSHIP_FORM_FIELDS } from './ownership-constant'


const OwnershipList = ({ resource, handleClickOpen, getInputFieldPropsFn, handleSubmitFn }) => {
  const {navigateToDashBoard}=useCommonfn()
  if (!resource) {
    throw new Promise(() => { })
  }
  const bankRes = resource.read();


  return (

    <>
       <Card>
        <CardHeading Divider>
          Ownership Information
          {bankRes?.data?.data?.
            ownerships?.length > 0 && <Button
              color="primary"
              size="sm"
              variant="contained"
              icon={<TbUserSquareRounded />}
              onClick={handleClickOpen}
            >
              Add New
            </Button>}
          </CardHeading>
      {
        bankRes?.data?.data?.
          ownerships?.length > 0 ? <>
            
              <Row rowGap mb={20}>
              {bankRes?.data?.data?.ownerships?.map((item, index) => (
                <Col sm={12} md={6} lg={6} xl={4} key={index}>
                  <CardViewBox >
                    <Row alignItem="center" mb={15}>
                      <Col sm={12} md={"auto"} xxl={3}>
                        <Avatar initials={shortFormName(item?.name || "-")} color={"primary"} />
                      </Col>

                      <Col sm={12} md={6} lg={6} xxl={7}>
                        <Typography variant="body1" strong mb={"0"} color="primary" wordBreak>
                          {item?.name ?? "-"}
                        </Typography>
                        <Typography
                          variant="body2"
                          mb={"0"}
                          color="dark"
                          Colorvariant="light"
                        >
                          {item?.designation ?? "-"}
                        </Typography>
                      </Col>
                      <Col sm={"auto"} ml={"auto"}>
                        <FabButton
                          icon={<TbPencil />}
                          shape="rounded"
                          size="sm"
                          variant="filled"
                          onClick={() => {
                            logger.log(item, "helllo")
                            handleClickOpen(null, item)
                          }}
                        // setData={(data) => {
                        //   handleClickOpen(null, data)
                        // }}
                        />
                      </Col>
                    </Row>
                    <CardViewBoxBorder />
                    <Flex alignItem="center" gap={"5"}>
                      <Icon size={"sm"}>
                        <TbPhone />
                      </Icon>
                      <Typography variant="body2" mb={"0"}>
                        {item?.phone || "-"}
                      </Typography>
                    </Flex>

                    <Flex alignItem="center" gap={"5"}>
                      <Icon size={"sm"}>
                        <TbMail />
                      </Icon>

                      <Typography variant="body2" mb={"0"}>
                        {item?.email || "-"}
                      </Typography>
                    </Flex>

                    <CardViewBoxBorder />
                    <Row mb={10}>
                      <Col sm={"auto"}>
                        <Typography variant="body2" mb={"0"}>
                          PAN: {item?.pan || "-"}
                        </Typography>
                      </Col>
                      <Col sm={"auto"}>
                        <Typography variant="body2" mb={"0"}>
                          ID No: {item?.identity_no || "-"}
                        </Typography>
                      </Col>
                    </Row>
                  </CardViewBox>
                </Col>
              ))}
              </Row>
        </> : <>
          <Row rowGap>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                {...getInputFieldPropsFn(OWNERSHIP_FORM_FIELDS.name.name)}
              />
            </Col>

            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                {...getInputFieldPropsFn(OWNERSHIP_FORM_FIELDS.phone.name)}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                {...getInputFieldPropsFn(OWNERSHIP_FORM_FIELDS.email.name)}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                {...getInputFieldPropsFn(OWNERSHIP_FORM_FIELDS.designation.name)}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                {...getInputFieldPropsFn(OWNERSHIP_FORM_FIELDS.identity_no.name)}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                {...getInputFieldPropsFn(OWNERSHIP_FORM_FIELDS.pan.name)}
              />
            </Col>




          </Row>
          <Gap height={100} />
          <Flex justifyContent="flex-end" gap={"10"}>
            <Button onClick={navigateToDashBoard} variant="outlined">
              Cancel
            </Button>

            <Button color="primary" onClick={handleSubmitFn} variant="contained">
              Submit
            </Button>
          </Flex> </>
      }
      </Card>

    </>

  )
}

export default OwnershipList